<template>
<svg width="14" height="16" viewBox="0 0 14 16" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd"
        d="M10.6133 7.99993L2.85664 3.52162L2.85664 12.4782L10.6133 7.99993ZM12.0233 8.60614C12.49 8.33671 12.49 7.66314 12.0233 7.39371L2.67664 1.99741C2.20997 1.72798 1.62664 2.06477 1.62664 2.60363L1.62664 13.3962C1.62664 13.9351 2.20997 14.2719 2.67664 14.0024L12.0233 8.60614Z"
        fill="#B5C6D8"/>
</svg>
</template>
